const trainingRelationStatuses = [
  {
    name: "High",
    value: "HIGH",
  },
  {
    name: "Medium",
    value: "MEDIUM",
  },
  {
    name: "Low",
    value: "LOW",
  },
];

export default trainingRelationStatuses;
